import http from '@/utils/http'
import { settlement } from '@/api/url'

export const initLiveness = (data) => {
  return http({
    url: settlement.initLiveness,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    },
    version: '003',
    errorToast: true
  })
}

export const listSettlement = (data) => {
  return http({
    url: settlement.listSettlement,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    },
    version: '003',
    errorToast: true
  })
}
export const billConfirm = (data) => {
  return http({
    url: settlement.billConfirm,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    },
    version: '003',
    errorToast: true
  })
}
export const updateBankInfo = (data) => {
  return http({
    url: settlement.updateBankInfo,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    },
    version: '003',
    errorToast: true
  })
}
export const uploadInvoice = (data) => {
  return http({
    url: settlement.uploadInvoice,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    },
    version: '003',
    errorToast: true
  })
}
export const getCurrentSettlementInfo = (data) => {
  return http({
    url: settlement.getCurrentSettlementInfo,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    },
    version: '003',
    errorToast: true
  })
}
export const listInvoiceInfo = (data) => {
  return http({
    url: settlement.listInvoiceInfo,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    },
    version: '003',
    errorToast: true
  })
}
export const modifyInvoiceInfo = (data) => {
  return http({
    url: settlement.modifyInvoiceInfo,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    },
    version: '003',
    errorToast: true
  })
}
export const faceVerification = (data) => {
  return http({
    url: settlement.faceVerification,
    method: 'post',
    data: data,
    headers: {
      'Content-Type': 'application/json'
    },
    version: '003',
    errorToast: true
  })
}
